import constants from "../../constants";

export default {
  getActionLogActionNameLabel(actionName) {
    switch (actionName) {
      case constants.ACTION_LOG_ACTION_NAME.VB_OUTGOING_DOC.SUA_SAI:
        return "Sửa sai văn bản ban hành";
      default:
        return actionName;
    }
  },

  // Sắp xếp kết quả sao cho những văn bản có Số ký hiệu chứa từ khóa lên đầu
  searchAndSort(keyword, documents) {
    if (documents && documents.length <= 0) {
      return documents;
    }
    documents.sort((a, b) => {
      const aMatchNumber = a && a['docCode'] && a['docCode'].includes(keyword);
      const bMatchNumber = b && b['docCode'] && b['docCode'].includes(keyword);
      if (aMatchNumber && !bMatchNumber) {
        return -1;
      } else if (!aMatchNumber && bMatchNumber) {
        return 1;
      } else {
        return 0;
      }
    });
    return documents;
  }
};



// WEBPACK FOOTER //
// ./src/services/doc/vbUtils.js